/** @format */

import { Row, Col } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { warehouseListColumns } from "../../../constants/tables/warehouseListColumns";
import { actionWarehouseListRequest } from "../../../redux-modules/actions/actionsWarehouses";
import {
  selectorWarehouseListLoading,
  selectorWarehouseDeleted,
} from "../../../redux-modules/selectors/selectorsUI";
import { selectorWarehouseList } from "../../../redux-modules/selectors/selectorsWarehouses";
import { BaseColor } from "../../../theme/maps/Colors";
import { Routes } from "../../../utils/Routes";
import { UIButton } from "../../ui/Button";
import { UICard } from "../../ui/Card";
import { UILink } from "../../ui/Link";
import { UITable } from "../../ui/Table";
import { UITitle } from "../../ui/Title";
import UITransition from "../../ui/Transition";

export const ViewWarehouseList = () => {
  const dispatch = useDispatch();
  const warehouseList = useSelector(selectorWarehouseList);
  const warehouseListLoading = useSelector(selectorWarehouseListLoading);
  const isWarehouseDeleted = useSelector(selectorWarehouseDeleted);

  useEffect(() => {
    dispatch(actionWarehouseListRequest());
  }, []);

  useEffect(() => {
    if (isWarehouseDeleted) dispatch(actionWarehouseListRequest());
  }, [isWarehouseDeleted]);

  return (
    <UITransition>
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col>
          <UITitle level={2} color={BaseColor} data-cy="page-title">
            Magazzini
          </UITitle>
        </Col>
        <Col>
          <UILink
            data-cy="new-warehouse-button"
            route={Routes.warehousesNew}
            label={<UIButton type="primary">+ Aggiungi Magazzino</UIButton>}
          />
        </Col>
      </Row>
      <UICard>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <UITable
              size="middle"
              data-cy="warehouse-list-table"
              loading={warehouseListLoading}
              columns={warehouseListColumns}
              dataSource={warehouseList}
            />
          </Col>
        </Row>
      </UICard>
    </UITransition>
  );
};
